import { AxiosResponse } from 'axios';
import { httpApi } from '../config/http.api';

const BASE_SUB_PATH = 'notifications';

export const getNotificationServiceApi = (): Promise<AxiosResponse> => httpApi.get(`${BASE_SUB_PATH}/me`);

export const deleteNotificationServiceApi = (notificationId: string): Promise<AxiosResponse> =>
  httpApi.delete(`${BASE_SUB_PATH}/${notificationId}`);
